<template>
  <aside id="left-sidebar">
    <div class="scrollbar scrollbar-inner">
      <div
        class="vuebar-element"
        v-bar
      >
        <!-- el1 -->
        <div>
          <header id="header">
            <img
              src="assets/images/mfs-logo.png"
              alt=""
              class="mfs-logo"
            >
            <!-- {{$t('sidebar.lblNai')}}<span>&nbsp;{{$t('sidebar.lblTalim')}}</span> -->
          </header>
          <section class="box-profile">
            <div class="profile-img">
              <span v-if="true">
                <img
                  src="assets/images/user.png"
                  alt=""
                >
              </span>
              <!--     <b-dropdown id="ddown1" variant="link" class="m-md-2">
                                <template slot="button-content">
                                    <i class="lnr lnr-menu"></i>
                                </template>
                                <b-dropdown-item>First Action</b-dropdown-item>
                                <b-dropdown-item>Second Action</b-dropdown-item>
                                <b-dropdown-item>Third Action</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item>Something else here...</b-dropdown-item>
                                <b-dropdown-item disabled>Disabled action</b-dropdown-item>
                            </b-dropdown> -->

            </div>
            <div class="profile-details">
              <span v-if="universityData">
                <div class="ptext">{{(universityData.uniAbbr)}}</div>
              </span>
              <span v-else>university Name
              </span>
            </div>
            <!-- <div class="profile-details" v-if="candidateProfile.profileData">
                            <div class="pname">{{candidateProfile.profileData.personalDetails.fullName}}</div>
                            <div class="ptext">{{candidateProfile.admissionData.industryPartner.name}}</div>
                        </div> -->
          </section>
          <nav class="mm-holder">
            <ul class="main-menu">
              <li @click="togglesidebar">
                <router-link to="/dashboard"> <i class="lnr lnr-home"></i>{{$t('sidebar.lblDashboard')}}</router-link>
              </li>
              <li @click="togglesidebar">
                <router-link to="/reports"> <i class="lnr lnr-file-empty"></i>{{$t('sidebar.lblReports')}}</router-link>
              </li>
              <!-- <li  @click="togglesidebar">
                                <router-link to="/attendance-quiz"><i class="lnr lnr-calendar-full"></i>Attendance Quiz</router-link>
                            </li>
                            <li  @click="togglesidebar">
                                <router-link to="/webcasts"><i class="lnr lnr-screen"></i>Webcast / Lecture</router-link>
                            </li>
                            <li @click="togglesidebar">
                                <router-link to="/my-plan-for-the-day"><i class="lnr lnr-map"></i>My Plan for the Day</router-link>
                            </li>
                            <li @click="togglesidebar">
                                <router-link to="/rating-self"><i class="lnr lnr-briefcase"></i>Selft Rating for My Work</router-link>
                            </li>
                            <li @click="togglesidebar">
                                <router-link to="/rating-appraiser"><i class="lnr lnr-star"></i>Ratings from Appraiser</router-link>
                            </li>
                            <li @click="togglesidebar">
                                <router-link to="/reflection"><i class="lnr lnr-film-play"></i>Reflection</router-link>
                            </li>
                            <li><a href="http://eranew.mkcl.org/ERA/login/loginpage" target="_blank"><i class="lnr lnr-sun"></i>eLearning</a></li>
                            <li @click="togglesidebar">
                                <router-link to="/profile"><i class="lnr lnr-camera"></i>Profile/ Biodata</router-link>
                            </li>
                            <li @click="togglesidebar">
                                <router-link to="/other-references"><i class="lnr lnr-layers"></i>Other Refernces</router-link>
                            </li> -->
            </ul>
          </nav>
          <!-- <div class="btn-holder">
                        <button class="btn btn-grey"><i class="lnr lnr-upload"></i>Upload Report</button>
                    </div> -->
          <footer
            class="fixed-bottom"
            id="footer"
          >
            &copy; {{this.copyrightInfo}} <br>
          </footer>
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
import MQL from "@/plugins/mql.js";
export default {
  name: "sidebar",
  data() {
    return {
      uniLogo: '',
      copyrightInfo: "",
      universityData: {}
    };
  },
  created() {
    this.GetProjectConfigService();
   // this.getCopyRightInfo()
  },
  methods: {
    getCopyRightInfo() {
      let vm = this
      // this.candidateProfile = this.$store.getters.getHeaderData;
      new MQL()
        .setActivity("r.[query_1I4CaJ2pPRmwREyoOn4gM2m2NjA]")
        .setData({})
        .fetch()
        .then(rs => {
          if (rs.isValid("query_1I4CaJ2pPRmwREyoOn4gM2m2NjA", true)) {
            let res = rs.getActivity("query_1I4CaJ2pPRmwREyoOn4gM2m2NjA", true);
            this.copyrightInfo = res[0].copyrightInfo
            // this.candidateProfile = rs.getActivity("query_1I4CaJ2pPRmwREyoOn4gM2m2NjA", true).result
          } else {
            rs.showErrorToast("query_1I4CaJ2pPRmwREyoOn4gM2m2NjA")
          }
        })
    },
    togglesidebar: function () {
      if (window.matchMedia("(max-width: 700px)").matches) {
        var element3 = document.getElementById("left-sidebar");
        element3.classList.add("active");
        var element4 = document.getElementById("main-content");
        element4.classList.add("active");
      }
    },
    GetProjectConfigService() {

      let vm = this;
      new MQL()
        .setActivity("o.[GetProjectConfigService]")
        .fetch()
        .then(rs => {
          let res = rs.getActivity("GetProjectConfigService", true);
          // this.portalUrls = .otherPortalUrls; //res.projectConfig.otherPortalUrls
          this.universityData = res.result.universityDetails
           this.copyrightInfo = res.result.copyrightInfo
          this.displayLogo()
          if (rs.isValid("GetProjectConfigService")) {
          } else {
            rs.showErrorToast("GetProjectConfigService");
          }
        });


    },
    displayLogo() {
      this.uniLogo = 'assets/images/' + this.universityData.uniAbbr + '.png'
    }
  },
  mounted() { },
  computed: {}
};
</script>
<style lang="scss">
.router-link-exact-active {
  color: #fff;
  background: rgba(255, 255, 255, 0.07);
  -webkit-box-shadow: inset 4px 0 0 0 #4faaff;
  box-shadow: inset 4px 0 0 0 #4faaff;
}
.mfs-logo {
  width: 70px;
}
</style>